import React from 'react';
import ReactDOM from 'react-dom/client';
import './__base.scss';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
// import { Provider } from 'react';
// import store from './redux/store';
import { HelmetProvider } from "react-helmet-async"
import './language/i18n';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './config/queryClient';

// Tự động chuyển hướng nếu truy cập qua domain hsvcorp.com.vn sang www.hsv.com.vn
if (typeof window !== 'undefined' && window.location) {
    const hostname = window.location.hostname.toLowerCase();
    if (hostname === 'www.hsvcorp.com.vn' || hostname === 'hsvcorp.com.vn') {
        const target = `https://www.hsv.com.vn${window.location.pathname}${window.location.search}${window.location.hash}`;
        window.location.replace(target);
    }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <QueryClientProvider client={queryClient}>
        <BrowserRouter>
            <HelmetProvider>
                <App />
            </HelmetProvider>
        </BrowserRouter>
    </QueryClientProvider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
